export default "__VITE_ASSET__5sX6aOh$__"